import React from "react";
import Navbar from '../../components/Navbar';
import Footer from "../footer/Footer";
import Header from "./Header";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import './whyus.css';

const Whyus = () =>{

    return(
        <>
       <Navbar/>
        <Header/>
        <Section1/>
        <Section2/>
        <Section3/>
        <Section4/>
        <Section5/>
        <Section6/>
        <Footer/>
       </>

    )


}

export default Whyus;